import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, InfiniteTable, DLMenu, ExternalLink } from 'appSrc/components/UI';
import EditVanityLinkModal from '../../Modals/VanityLink/EditVanityLinkModal';
import { CopyDrop } from '../../Common';
import style from './styles/style.module.css';

class AllVanitylinksTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            vanityLinkInEdit: null,
            vanityLinkInEditIndex: -1,
        };
    }
    updateVanityLink = ( index, desireid, data ) => {
        this.props.updateVanityLink( desireid, data )
        .then( ( vanityLink ) => {
            return this.props.onVanityLinkUpdated && this.props.onVanityLinkUpdated( index, vanityLink );
        } );
    }
    openEditModal = ( index, vanityLink ) => {
        this.setState( { vanityLinkInEdit: vanityLink, vanityLinkInEditIndex: index } );
    }
    onEditSubmit = ( vanityLink ) => {
        var index = this.state.vanityLinkInEditIndex;
        this.props.onVanityLinkUpdated( index, vanityLink );
        this.setState( { vanityLinkInEdit: null, vanityLinkInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { vanityLinkInEdit: null, vanityLinkInEditIndex: -1 } );
    }



    render() {
        const { vanityLinks } = this.props;
        const { vanityLinkInEdit } = this.state;

        return (
            <div>
                <InfiniteTable
                className={ style.vanityLinksTable }
                elementHeight={ 90 }>
                    { this.arrayTableRows( vanityLinks ) }
                </InfiniteTable>
                { vanityLinkInEdit !== null &&
                    <EditVanityLinkModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    vanityLink={ vanityLinkInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( vanityLinks ) => {
        var rows = vanityLinks.map( ( vanityLink, index ) => {
            var publicSlug = 'https://' + process.env.VANITY_HOST + vanityLink.vanity_url_path;
            return (
                <InfiniteTable.Row key={ vanityLink.id } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } direction='right' />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.vanityLinktext }>
                        { vanityLink.vanity_url_path }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <ExternalLink to={ vanityLink.redirect_url } title={ vanityLink.redirect_url }></ExternalLink>
                        <span className={ style.destinationText }>{ vanityLink.redirect_url }</span>
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, vanityLink );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    VANITY PATH { sortIcon( 'vanity_url_path' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    DESTINATION URL { sortIcon( 'redirect_url,vanity_url_path' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllVanitylinksTable.defaultProps = {
    onVanityLinkUpdated: ()=>{},
};

export default connect()( AllVanitylinksTable );
